import { render, staticRenderFns } from "./Special_Price.vue?vue&type=template&id=0dd6c8ad&scoped=true&"
import script from "./Special_Price.vue?vue&type=script&lang=js&"
export * from "./Special_Price.vue?vue&type=script&lang=js&"
import style0 from "./Special_Price.vue?vue&type=style&index=0&id=0dd6c8ad&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd6c8ad",
  null
  
)

export default component.exports